import { Group, Paper, Stack, Text as MText, Title } from '@mantine/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { FieldStatus } from '../../data-access/types/stats';
import { Crop, CropInfo } from '../../types/dashboard-recap.type';
import { formatSectorData } from '../../utils/format-sectors-data';
import DoubleDonutChart from '../double-donut-chart/double-donut-chart';

import styles from './fields-status-synthesis.module.css';

import { camelinePng, tournesolPng } from '@assets';

const image = {
  sunflower: tournesolPng,
  camelina: camelinePng,
};

const getImage = (crop: string) => {
  return image[crop as Crop];
};

interface FieldsStatusSynthesisProps {
  crop: string;
  data: FieldStatus;
}

export function FieldsStatusSynthesis({
  crop,
  data,
}: FieldsStatusSynthesisProps) {
  const { t } = useTranslation();

  return (
    <Stack className={clsx(styles.container)} gap={0}>
      <Group>
        <img alt="tournesol" height={40} src={getImage(crop)} />
        <Title order={3}>{t(`common.crops.${crop}`)}</Title>
      </Group>
      <Group grow h="100%" w="100%">
        <Stack align="center" gap="md" justify="space-around">
          <DoubleDonutChart
            centerLabel={data.nbr_plots + ' ' + t('common.fields')}
            data01={formatSectorData(data, 'number', t('common.fields'))}
            data02={formatSectorData(data, 'area', 'ha')}
            withTooltip={data.nbr_plots + data.total_area > 0}
          />
          <MText fw="bold">{data.total_area} ha</MText>
        </Stack>
      </Group>
    </Stack>
  );
}

export default FieldsStatusSynthesis;
